export enum AttractionSignificanceLayer {
  MinimalSignificance = "MinimalSignificance",
  LowSignificance = "LowSignificance",
  MediumSignificance = "MediumSignificance",
  HighSignificance = "HighSignificance",
  VeryHighSignificance = "VeryHighSignificance"
}
